'use client'

import { cn } from '@mntn-dev/ui-utilities'
import type { CSSProperties, PropsWithChildren, RefAttributes } from 'react'
import { forwardRef } from '../../utils/forward-ref.ts'
import type { CardScale } from './use-card.ts'

export type CardsCompactProps = PropsWithChildren<
  RefAttributes<HTMLDivElement> & {
    className?: string
    style?: CSSProperties
  }
>

export const scaleHeightMap: Record<CardScale, number> = {
  sm: 56,
  md: 76,
  lg: 88,
}

export const getCardCompactHeight = (scale: CardScale) => {
  return () => scaleHeightMap[scale]
}

export const CardsCompact = forwardRef<HTMLDivElement, CardsCompactProps>(
  ({ children, className, style }, ref) => {
    return (
      <div
        ref={ref}
        className={cn('w-full flex flex-col gap-y-2', className)}
        style={style}
      >
        {children}
      </div>
    )
  }
)
